$(document).ready(function () {
	$(".change-s__cont__kv.accord").on("click", function () {
		$(this).next(".change-s__cont__main").slideToggle();
	});
});
